import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationUpdateCustomerUserArgs, BackendUser } from 'src/types/backend';

import { USER_FRAGMENT } from '../user/schema';

const MUTATION = gql`
  mutation UpdateCustomerUser($id: ID!, $name: String!) {
    updateCustomerUser(id: $id, name: $name) {
      ...User
    }
  }
  ${USER_FRAGMENT}
`;

type Variables = BackendMutationUpdateCustomerUserArgs;
type Result = BackendUser;

export const updateCustomerUser = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
